import { NgModule, Injector, Injectable } from '@angular/core';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
//import { NgModule, Injector, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule } from '@ionic/angular';
//import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Push } from "@ionic-native/push/ngx";
import { Camera } from '@ionic-native/camera/ngx';
import { Calendar } from "@ionic-native/calendar/ngx";
import { Insomnia } from "@ionic-native/insomnia/ngx";
import { ImagePicker } from "@ionic-native/image-picker/ngx";
import { FileTransfer } from "@ionic-native/file-transfer/ngx";
import { File } from '@ionic-native/file/ngx';
import { SignInWithApple } from '@ionic-native/sign-in-with-apple/ngx';
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';

// setting
import { CustomRouteReuseStrategy } from './settings/routing.strategy';

// modules
import { SharedModule } from "./modules/shared.module";

// pages modules
import { LoginPageModule } from "./pages/login/login.module";
import { LostPasswordPageModule } from "./pages/lost-password/lost-password.module";
import { SetPasswordPageModule } from "./pages/set-password/set-password.module";
import { RegistrationPageModule } from "./pages/registration/registration.module";
import { TocPageModule } from "./pages/toc/toc.module";

// ionic modules
import { Drivers, Storage } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';

// other modules
import { Ng2UiAuthModule } from "ng2-ui-auth";
import { myAuthConfig } from "./settings/oauth.settings";
import { OauthCordova } from "ng2-cordova-oauth/platform/cordova";
import { AngularSvgIconModule } from 'angular-svg-icon';

// Http
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { JwtModule } from "@auth0/angular-jwt";

// translator
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// services
import { RequestInterceptService } from "./services/request-intercept.service";
import { ServiceLocatorService } from "./services/service-locator.service";
import { PlatformService } from "./services/platform.service";

// pipes
import { SafePipe } from './pipes/string/safe';

import { log } from "./helpers/log";

// config
import { environment } from '../environments/environment';

// sentry
import * as Sentry from '@sentry/browser';
import { ErrorHandler } from '@angular/core';

var ignoreErrors = [
    'overlay does not exist',
    'QuotaExceededError',
    'No JWT present or has expired'
];

if (environment.sentry.enabled) {
    Sentry.init({
        release: "congreet.pwa@" + environment.version,
        dsn: environment.sentry.dsn,
        ignoreErrors: ignoreErrors,
        beforeBreadcrumb(breadcrumb, hint) {
            if (breadcrumb.category === 'ui.click') {
                let el;
                if (hint.event instanceof HTMLElement) {
                    el = hint.event;
                }
                if (hint.event instanceof MouseEvent) {
                    el = hint.event.target;

                    breadcrumb.message += ' EVENT: MouseClick';
                }

                if (el) {
                    //const { target } = hint.event;
                    if (el.getRootNode && el.getRootNode() && el.getRootNode().host) {
                        if (el.getRootNode().host.id) {
                            breadcrumb.message += ' ID: ' + el.getRootNode().host.id;
                        }
                        if (el.getRootNode().host.innerText) {
                            breadcrumb.message += ' TEXT: ' + el.getRootNode().host.innerText;
                        }
                    }
                    if (el.id) {
                        breadcrumb.message += ' ID: ' + el.id;
                    }
                    if (el.innerText) {
                        breadcrumb.message += ' TEXT: ' + el.innerText;
                    }
                }
            }
            return breadcrumb;
        },
    });

    // https://www.npmjs.com/package/@sentry/browser
    Sentry.configureScope(scope => {
        scope.setExtra('environment', environment.name);
        //scope.setTag('user_mode', 'admin');
        //scope.setUser({ id: '4711' });
    });
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
    constructor() {
        if (environment.sentry.dialog) {
            let newcontent = document.createElement('div');
            newcontent.innerHTML = ' <style>#reports{position:fixed;top:0;left:0;width:100vw;margin:0;background:red;color:white;}#reports li{padding:8px;}</style><ul id="reports"></ul>';
            document.body.appendChild(newcontent);
        }
    }
    handleError(error) {
        // Sentry.captureException(error.originalError || error);
        // throw error;
        if ((error.hasOwnProperty('_body') && error.hasOwnProperty('headers') && error.hasOwnProperty('status')) || (error.hasOwnProperty('status') && error.status == 400)) {
            // API error, so don't create error report
        } else {
            if (environment.sentry.enabled) {
                let realError = error.originalError || error;
                const eventId = Sentry.captureException(realError);
                if (environment.sentry.dialog) {
                    let ignored = false;

                    ignoreErrors.forEach((ignoreError) => {
                        if (realError.message.search(ignoreError) != -1) {
                            ignored = true;
                        }
                    })

                    if (!ignored) {
                        //Sentry.showReportDialog({ eventId });
                        let newcontent = document.createElement('li');
                        newcontent.innerHTML = "There was an Javascript Error. SentryId: " + eventId;
                        document.getElementById('reports').appendChild(newcontent);
                    }
                }
            }
            if (environment.debug || !environment.sentry.enabled) {
                log('error', error.originalError || error);
            }
        }
    }
}

export function createTranslateLoader(
    http: HttpClient
) {
    if (environment.liveTranslation && navigator.onLine) {
        return new TranslateHttpLoader(http, environment.api + '/translation/file/');
    } else {
        return new TranslateHttpLoader(http, '/assets/i18n/', '.json?version=' + environment.version);
    }

}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        IonicModule.forRoot({
            mode: 'ios'
        }),
        AppRoutingModule,
        ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
        IonicStorageModule.forRoot({
            name: '__congreet',
            driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB, Drivers.LocalStorage]
        }),
        HttpClientModule,
        JwtModule.forRoot({
            config: {
                headerName: "Authorization",
                authScheme: "Bearer ",
                tokenGetter: () => {
                    return localStorage.getItem('token');
                },
                allowedDomains: ["assets.congreet.com", "server.congreet.com", "assets.coolgreet.de", "api.coolgreet.de", "api.dev.coolgreet.de", "server.congreet.loc", "localhost"],
                disallowedRoutes: [/\/api\/v2\/translation.*/]
            },
        }),
        // Ng2UiAuthModule.forRoot({
        //     providers: {
        //         linkedin: {
        //             clientId: environment.linkedIn.clientId
        //         }
        //     }
        // }),
        Ng2UiAuthModule.forRoot(myAuthConfig),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        AngularSvgIconModule.forRoot(),
        SharedModule,
        LoginPageModule,
        LostPasswordPageModule,
        SetPasswordPageModule,
        RegistrationPageModule,
        TocPageModule
    ],
    providers: [
        Camera,
        Calendar,
        Insomnia,
        ImagePicker,
        FileTransfer,
        File,
        StatusBar,
        Keyboard,
        SplashScreen,
        PlatformService,
        SignInWithApple,
        Push,
        { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
        { provide: ErrorHandler, useClass: SentryErrorHandler },
        //{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptService,
            multi: true
        },
        //{ provide: LOCALE_ID, useValue: 'de-DE'}
        OauthCordova,
        SafePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

    /**
     * constructor
     *
     * @return void
     */
    public constructor(private injector: Injector) {
        ServiceLocatorService.injector = this.injector;

        // set froala license
        localStorage.setItem('FEK', '6Ud1QBRVCDLPAZMBQ==');
    }
}
